import { on } from '../utils/_fn';

var ANIMATION_DURATION = 2000;

/**
 * initBrandLogoAnimation
 * hover 時加上 .is-animating 啟動漸層動畫，
 * mouseleave 後等待當前動畫週期結束才移除 class，確保動畫不會中途斷掉。
 * 僅在支援 hover 的裝置執行。
 */
export function initBrandLogoAnimation() {
  // 僅在支援 hover 的裝置執行
  if (!window.matchMedia('(hover: hover)').matches) return;

  var logoBox = document.querySelector('.hd__logo-box');
  if (!logoBox) return;

  var textEl = logoBox.querySelector('.brand-logo__text');
  if (!textEl) return;

  var isHovering = false;
  var timer = null;

  on(logoBox, 'mouseenter', function () {
    isHovering = true;
    if (timer) {
      clearTimeout(timer);
      timer = null;
    }
    textEl.classList.add('is-animating');
  });

  on(logoBox, 'mouseleave', function () {
    isHovering = false;

    // 計算距離下一個動畫週期結束的剩餘時間
    var animations = textEl.getAnimations ? textEl.getAnimations() : [];
    var remaining = ANIMATION_DURATION;

    if (animations.length > 0) {
      var currentTime = animations[0].currentTime || 0;
      var elapsed = currentTime % ANIMATION_DURATION;
      remaining = ANIMATION_DURATION - elapsed;
    }

    timer = setTimeout(function () {
      if (!isHovering) {
        textEl.classList.remove('is-animating');
      }
      timer = null;
    }, remaining);
  });
}
